<template>
 <div>
  <ExpertStatisticsTemplate
   :periodSelector="periodSelector"
   @timeSelector="setPeriod(startDate, endDate)"
   :elements="extensions"
   :clearTimeSelector="clearTimeSelector"
   @selector="
    $emit('update:selector', $event),
     $emit('setSelector', $event),
     $store.dispatch('pbxPeriodSelected', $event)
   "
   @setPeriod="(...args) => setPeriod(...args)"
   @download-report="downloadReport()"
   :startDate="startDate"
   :endDate="endDate"
   @activeBanner="$emit('activeBanner')"
   @successMsg="$emit('successMsg', $event)"
   @success="$emit('success', $event)"
   :urlType="urlType"
   @setLoading="$emit('setLoading', $event)">
   <template v-slot:selector>
    <PbxDashboardSelector
     :key="pbxElements"
     @selector="period = $event"
     @button-selector="(...args) => getSelectedButton(...args)"
     @action="
      $emit('action', $event), (selectedElement = $event), setTableData()
     "
     :selectHostname="selectHostname"
     :urlType="urlType"
     @queueName="selectedQueue = $event"
     :buttonSelected="buttonSelected"
     :elements="selectedElement"
     @timeSelector="setPeriod(startDate, endDate)"
     :concatenateData="concatenateData"
     @concatenate="concatenateData = $event"
     :groupDatesQueueReport="groupData" />
   </template>
   <template v-slot:content>
    <PbxHeader
     v-model:search="search"
     pbxMenuType="queueDetail"
     :periodSelector="period"
     :parseDateRange="parseDateRange"
     @select-hostname="selectHostname = $event"
     :selectedQueue="selectedQueue"
     :parseTimeRange="parseTimeRange"
     :timeSelected="selectedtime"
     :buttonSelected="buttonSelected"
     @activeBanner="(activeBanner = true), (key = !key)"
     @successMsg="successMsg = $event"
     @success="isSuccess = $event"
     urlType="queue" />

    <div class="" v-if="tableData?.length || tableDataConcatenated?.length">
     <div class="overflow-hidden border-gray-200 rounded-md">
      <FullReportTableUsers
       :key="stringOfQueues"
       :groupData="groupData"
       :currentSortDir="currentSortDir"
       :tableData="concatenateData ? tableDataConcatenated : filteredData"
       :header="tableHeader"
       :body="tableBody"
       :selectedtime="selectedtime"
       :extensionsArray="extensionsArray"
       v-model:searchExtension="searchExtension"
       v-model:searchQueue="searchQueue"
       :period="period"
       :parseDateRange="parseDateRange"
       :queuesOnlyStats="queuesOnlyStats"
       :timeRange="timeRange"
       :timeGap="timeGap"
       :numberOfColumns="numberOfColumns"
       :selectedRangeType="selectedRangeType"
       :concatenateData="concatenateData"
       :extensionsNameNumberArray="extensionsNameNumberArray"
       :queuesNameNumberArray="queuesNameNumberArray"
       @sort="sort($event)" />
     </div>
    </div>

    <div v-else class="mt-8 overflow-x-auto sm:-mx-6 lg:-mx-0">
     <div
      v-if="!this.pbxElements || this.pbxElements.length <= 0"
      class="text-center max-w-lg mx-auto space-y-4">
      <font-awesome-icon
       icon="chart-column"
       class="mx-auto h-10 w-10 text-teal-600"
       aria-hidden="true" />
      <h1 class="text-gray-900 font-bold text-2xl">
       Analysez la performance des agents dans les files d'attente.
      </h1>
      <h3 class="mt-2 text-lg font-medium text-gray-900">
       Suivez le temps de connexion des agents, le temps de connexion aux files,
       et les files d'attente traitées.
      </h3>
      <div class="pt-10">
       <PleaseSelectElement
        dataDescription="Veuillez sélectionner un utilisateur et une période" />
      </div>
     </div>
     <div
      v-else
      class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-6">
      <div class="overflow-hidden border-b border-gray-200 rounded-md">
       <NoData />
      </div>
     </div>
    </div>
   </template>
  </ExpertStatisticsTemplate>
 </div>
</template>

<script>
import PleaseSelectElement from "../../components/PleaseSelectElement.vue";
import PopupShareReport from "../../components/PBX/PopupShareReport.vue";
import HoverDatePicker from "../../components/PBX/HoverDatePicker.vue";
import ExpertStatisticsTemplate from "./ExpertStatisticsTemplate.vue";
import Tooltip from "../../components/Collect/formTools/Tooltip.vue";
import axios from "axios";
import { mapGetters } from "vuex";

import "vue-loading-overlay/dist/vue-loading.css";
import SuccessBanner from "../../components/SuccessBanner.vue";
import PbxHeader from "../../components/PBX/PbxHeader.vue";
import PbxDashboardSelector from "../../components/PBX/PbxDashboardSelector.vue";
import FullReportTableUsers from "../../components/PBX/FullReportTableUsers.vue";
import {
 Switch,
 SwitchGroup,
 SwitchLabel,
 Menu,
 MenuButton,
 MenuItem,
 MenuItems,
} from "@headlessui/vue";
import { ChevronDownIcon, XIcon } from "@heroicons/vue/outline";
import {
 ArrowCircleRightIcon,
 ArrowCircleLeftIcon,
 InformationCircleIcon,
} from "@heroicons/vue/solid";

export default {
 props: ["urlType"],
 components: {
  PbxHeader,
  PbxDashboardSelector,
  SuccessBanner,
  FullReportTableUsers,
  Switch,
  SwitchGroup,
  SwitchLabel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  ChevronDownIcon,
  Tooltip,
  ArrowCircleRightIcon,
  ArrowCircleLeftIcon,
  InformationCircleIcon,
  XIcon,
  ExpertStatisticsTemplate,
  HoverDatePicker,
  PopupShareReport,
  PleaseSelectElement,
 },
 data() {
  return {
   currentSortDir: "asc",
   currentSort: "",
   selectedRangeType: "waiting",
   selectedRangeTypeText: "Durées d'attente",
   groupData: true,
   searchQueue: null,
   searchQueueName: null,
   searchExtension: null,
   searchExtensionName: null,
   queuesNameArray: [],
   queuesArray: [],
   extensionsNameArray: [],
   extensionsNameNumberArray: [],
   queuesNameNumberArray: [],
   extensionsArray: [],
   queuesOnlyStats: true,
   data: {},
   selectedtime: undefined,
   fullPage: true,
   selectedElement: "",
   selectedQueue: "",
   period: "",
   selectHostname: "",
   queueData: [],
   extensionData: [],
   textMonth: "",
   buttonSelected: "month",
   successMsg: "",
   activeBanner: false,
   isSuccess: true,
   key: false,
   concatenateData: false,
   startDate: null,
   endDate: null,
   tableDataConcatenated: null,
   tableData: null,
   tableHeader: null,
   tableBody: null,
   stringOfQueues: "",
   listOfFilteredQueues: [],
  };
 },
 methods: {
  setPeriod(...args) {
   this.startDate = args[0];
   this.endDate = args[1];

   let flag = false;
   if (this.concatenateData) {
    flag = true;
    this.concatenateData = false;
   }
   this.setTableData();
   if (flag) this.concatenateData = true;
  },
  async getData(sentPeriod) {
   let arrayOfElements = [];
   let stringOfElements = "";
   if (
    this.pbxElements &&
    this.pbxElements.length > 0 &&
    this.startDate &&
    this.endDate
   ) {
    this.pbxElements.forEach((element, index) => {
     let elementValue = element;
     if (typeof elementValue === "object") {
      for (let index = 0; index < elementValue.length; index++) {
       const element = elementValue[index];
       arrayOfElements.push(element);
      }
     } else {
      arrayOfElements.push(element);
     }
    });

    arrayOfElements = [...new Set(arrayOfElements)];

    stringOfElements = String(arrayOfElements[0]);

    for (let index = 1; index < arrayOfElements.length; index++) {
     stringOfElements = stringOfElements + "," + String(arrayOfElements[index]);
    }
    let url = `${localStorage.getItem("apiUrl")}/api/v1.2/agent-stats/${
     this.hostName
    }/overview?start_date=${this.startDate}&end_date=${
     this.endDate
    }&user_dns=${stringOfElements}&queue_dns=${
     this.stringOfQueues
    }&start_time=${this.pbxTimeSelected[0]}&end_time=${
     this.pbxTimeSelected[1]
    }`;
    try {
     const res = await axios.get(url, {
      headers: {
       Authorization: "Bearer " + localStorage.getItem("apiToken"),
      },
     });

     return res.data;
    } catch (error) {
     this.errorHandling(error);
    }
   }
  },
  async setTableData() {
   this.tableData = [];
   this.tableDataConcatenated = [];
   this.$emit("setLoading", true);
   this.$store.dispatch("pbxElementType", this.urlType);
   const raw = await this.getData();
   const data = raw?.data || [];
   console.log("data ==> ", data);
   const queueSummaryMap = {};
   const fullQueueSummary = [];
   if (
    this.pbxMap &&
    this.pbxMap["call_queues"] &&
    this.pbxMap["extensions"] &&
    this.selectedElement
   ) {
    this.selectedElement = this.selectedElement?.map(res => {
     return (
      res +
      (this.urlType === "queue"
       ? this.pbxMap["call_queues"][res]
         ? "-" + this.pbxMap["call_queues"][res]["name"]
         : ""
       : this.pbxMap["extensions"][res]
       ? "-" + this.pbxMap["extensions"][res]
       : "")
     );
    });
   }

   // Create a lookup for queue_list by user_dn
   (raw?.summary?.queue_list || []).forEach(entry => {
    entry.queues_list.forEach(res => {
     fullQueueSummary.indexOf(res) < 0
      ? fullQueueSummary.push(res)
      : fullQueueSummary.splice(fullQueueSummary.indexOf(res), 1, res);
    });
   });

   this.tableHeader = [
    { text: "Utilisateur", info: "", hasInfo: false, key: "user" },
    // { text: "Files Travaillées", hasInfo: false },
    { text: "Files", hasInfo: false },
    // { text: "Connexions File", hasInfo: false },
    // { text: "Connexions PBX", hasInfo: false },
    // { text: "Total Interactions", hasInfo: false },
    {
     text: "Conn. File (%)",
     hasInfo: false,
     key: "queue_connection_percentage",
    },
    { text: "Conn. PBX (%)", hasInfo: false, key: "pbx_connection_percentage" },
    {
     text: "Disponibilité (%)",
     hasInfo: false,
     key: "availability_percentage",
    },
    { text: "Temps Connecté", hasInfo: false, key: "total_connected_time" },
    {
     text: "Temps Connecté File",
     hasInfo: false,
     key: "total_queue_connected_time",
    },
   ];

   this.tableBody = [
    "user",
    // "queues_worked",
    "queues",
    // "queue_connected_records",
    // "pbx_connected_records",
    // "total_records",
    "queue_connection_percentage",
    "pbx_connection_percentage",
    "availability_percentage",
    "total_connected_time",
    "total_queue_connected_time",
   ];

   if (data?.length) {
    const formattedData = data.map(entry => ({
     user:
      entry.user_dn +
      (this.urlType === "queue"
       ? this.pbxMap["call_queues"][entry.user_dn]
         ? "-" + this.pbxMap["call_queues"][entry.user_dn]["name"]
         : ""
       : this.pbxMap["extensions"][entry.user_dn]
       ? "-" + this.pbxMap["extensions"][entry.user_dn]
       : ""),
     queues_worked: parseInt(entry.queues_worked, 10) || 0,
     queues:
      entry.queues_list?.length > 0
       ? entry.queues_list.map(
          res =>
           res +
           (this.pbxMap["call_queues"][res]
            ? "-" + this.pbxMap["call_queues"][res]["name"]
            : "")
         )
       : "-",
     queue_connected_records: parseInt(entry.queue_connected_records, 10) || 0,
     pbx_connected_records: parseInt(entry.pbx_connected_records, 10) || 0,
     total_records: parseInt(entry.total_records, 10) || 0,
     queue_connection_percentage:
      entry.queue_connection_percentage != null
       ? entry.queue_connection_percentage.toFixed(2) + "%"
       : "N/A",
     pbx_connection_percentage:
      entry.pbx_connection_percentage != null
       ? entry.pbx_connection_percentage.toFixed(2) + "%"
       : "N/A",
     availability_percentage:
      entry.availability_percentage != null
       ? entry.availability_percentage.toFixed(2) + "%"
       : "N/A",
     total_connected_time: entry.total_connected_time || "00:00",
     total_queue_connected_time: entry.total_queue_connected_time || "00:00",
    }));

    this.tableData = formattedData;
    this.tableDataConcatenated[0] = this.consolidateData(
     formattedData,
     fullQueueSummary
    );
    this.extensionsNameNumberArray = formattedData.map(res => res.user);
    this.queuesNameNumberArray = fullQueueSummary.map(res => {
     return this.pbxMap["call_queues"][res]
      ? res + "-" + this.pbxMap["call_queues"][res]["name"]
      : res;
    });
   }

   this.$emit("setLoading", false);
  },
  consolidateData(data, fullQueueSummary) {
   const consolidated = {
    user: " - ",
    queues: fullQueueSummary
     ? fullQueueSummary.map(res => {
        return this.pbxMap["call_queues"][res]
         ? res + "-" + this.pbxMap["call_queues"][res]["name"]
         : res;
       })
     : [],
    queues_worked: 0,
    queue_connected_records: 0,
    pbx_connected_records: 0,
    total_records: 0,
    queue_connection_percentage: 0,
    pbx_connection_percentage: 0,
    availability_percentage: 0,
    total_connected_minutes: 0,
    total_queue_connected_minutes: 0,
   };

   let queueConnCount = 0;
   let pbxConnCount = 0;
   let availCount = 0;

   data.forEach(row => {
    consolidated.queues_worked += row.queues_worked;
    consolidated.queue_connected_records += row.queue_connected_records;
    consolidated.pbx_connected_records += row.pbx_connected_records;
    consolidated.total_records += row.total_records;

    const qcp = parseFloat(row.queue_connection_percentage);
    if (!isNaN(qcp)) {
     consolidated.queue_connection_percentage += qcp;
     queueConnCount++;
    }

    const pcp = parseFloat(row.pbx_connection_percentage);
    if (!isNaN(pcp)) {
     consolidated.pbx_connection_percentage += pcp;
     pbxConnCount++;
    }

    const ap = parseFloat(row.availability_percentage);
    if (!isNaN(ap)) {
     consolidated.availability_percentage += ap;
     availCount++;
    }

    const [hhq, mmq] = (row.total_queue_connected_time || "00:00")
     .split(":")
     .map(n => parseInt(n, 10));
    consolidated.total_queue_connected_minutes += hhq * 60 + mmq;

    const [hh, mm] = (row.total_connected_time || "00:00")
     .split(":")
     .map(n => parseInt(n, 10));
    consolidated.total_connected_minutes += hh * 60 + mm;
   });

   consolidated.queue_connection_percentage = queueConnCount
    ? (consolidated.queue_connection_percentage / queueConnCount).toFixed(2) +
      "%"
    : "N/A";

   consolidated.pbx_connection_percentage = pbxConnCount
    ? (consolidated.pbx_connection_percentage / pbxConnCount).toFixed(2) + "%"
    : "N/A";

   consolidated.availability_percentage = availCount
    ? (consolidated.availability_percentage / availCount).toFixed(2) + "%"
    : "N/A";

   const totalMinsQueue = consolidated.total_queue_connected_minutes;
   const hq = String(Math.floor(totalMinsQueue / 60)).padStart(2, "0");
   const mq = String(totalMinsQueue % 60).padStart(2, "0");
   consolidated.total_queue_connected_time = `${hq}:${mq}`;

   delete consolidated.total_queue_connected_minutes;

   const totalMins = consolidated.total_connected_minutes;
   const h = String(Math.floor(totalMins / 60)).padStart(2, "0");
   const m = String(totalMins % 60).padStart(2, "0");
   consolidated.total_connected_time = `${h}:${m}`;

   delete consolidated.total_connected_minutes;

   return consolidated;
  },
  async downloadReport() {
   let arrayOfElements = [];
   let stringOfElements = "";
   if (
    this.pbxElements &&
    this.pbxElements.length > 0 &&
    this.startDate &&
    this.endDate
   ) {
    this.$emit("setLoading", true);
    this.pbxElements.forEach((element, index) => {
     let elementValue = element;
     if (typeof elementValue === "object") {
      for (let index = 0; index < elementValue.length; index++) {
       const element = elementValue[index];
       arrayOfElements.push(element);
      }
     } else {
      arrayOfElements.push(element);
     }
    });

    arrayOfElements = [...new Set(arrayOfElements)];

    stringOfElements = String(arrayOfElements[0]);

    for (let index = 1; index < arrayOfElements.length; index++) {
     stringOfElements = stringOfElements + "," + String(arrayOfElements[index]);
    }
    const params = {
     start_date: this.startDate,
     end_date: this.endDate,
     dn: stringOfElements, // Replace with your DID number or dynamic value
     start_time: this.pbxTimeSelected[0], // Optional, adjust as necessary
     end_time: this.pbxTimeSelected[1], // Optional, adjust as necessary
    };
    let url = `${localStorage.getItem("apiUrl")}/api/v1.2/${
     this.hostName
    }/users-report-file`;
    try {
     const res = await axios.post(url, params, {
      headers: {
       Authorization: "Bearer " + localStorage.getItem("apiToken"),
      },
      responseType: "blob",
     });
     const blob = new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
     });
     const link = document.createElement("a");
     link.href = window.URL.createObjectURL(blob);
     // Set the filename
     const reportDate = `${params.start_date}_to_${params.end_date}`;
     link.download = `Users_Report_${reportDate}.xlsx`;

     // Trigger the download
     link.click();
     window.URL.revokeObjectURL(link.href);
    } catch (error) {
     this.errorHandling(error);
    }
   }
   if (!this.pbxElements || this.pbxElements.length == 0) {
    this.$emit("activeBanner");
    this.$emit("success", false);
    this.$emit("successMsg", "Veuillez sélectionner un ou plusieurs numéros");
   }
   this.$emit("setLoading", false);
  },
  sort(s) {
   if (s === this.currentSort) {
    this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
   }
   this.currentSort = s;
  },
  sortedData() {
   const extensionData = this.tableData;
   let extensionDataSorted = extensionData.sort((a, b) => {
    let toBeSorted = this.currentSort;
    let modifier = 1;
    if (this.currentSortDir === "desc") modifier = -1;
    if (parseInt(a[toBeSorted]) < parseInt(b[toBeSorted])) return -1 * modifier;
    if (parseInt(a[toBeSorted]) > parseInt(b[toBeSorted])) return 1 * modifier;
    return 0;
   });
   return extensionDataSorted;
  },
  parseDateRange(date) {
   if (date.length === 8) {
    let year = ("0" + date).slice(1, -4);
    let month = ("0" + date).slice(-4, -2);
    let day = ("0" + date).slice(-2);
    let fullDay = "";
    fullDay = day + "/" + month + "/" + year;
    return String(fullDay);
   } else if (date.length === 6) {
    let year = ("0" + date).slice(1, 5);
    let month = ("0" + date).slice(-2);
    let fullDay = "";
    fullDay = month + "/" + year;
    return String(fullDay);
   } else if (date.length === 17) {
    let fullDay = date.split("-");
    let firstYear = ("0" + fullDay[0]).slice(1, 5);
    let firstMonth = ("0" + fullDay[0]).slice(-4, -2);
    let firstDay = ("0" + fullDay[0]).slice(-2);

    let firstFullDay = "";
    firstFullDay = firstDay + "/" + firstMonth + "/" + firstYear;

    let lastYear = ("0" + fullDay[1]).slice(1, 5);
    let lastMonth = ("0" + fullDay[1]).slice(-4, -2);
    let lastDay = ("0" + fullDay[1]).slice(-2);

    let lastFullDay = "";
    lastFullDay = lastDay + "/" + lastMonth + "/" + lastYear;
    let finalDay = "";
    finalDay = firstFullDay + " - " + lastFullDay;
    return String(finalDay);
   } else {
    return date;
   }
  },
  parseTimeRange(time) {
   if (time && time.length > 0) {
    const timeStart = time[0].slice(0, 2) + ":" + time[0].slice(2);
    const timeEnd = time[1].slice(0, 2) + ":" + time[1].slice(2);
    const finalTime = timeStart + " - " + timeEnd;
    return String(finalTime);
   }
  },
 },
 watch: {
  selectedtime: function (val) {
   let flag = false;
   if (this.concatenateData) {
    flag = true;
    this.concatenateData = false;
   }
   //  this.setTableData();
   //  this.separateQueueExtensionData();
   if (flag) this.concatenateData = true;
  },
  urlType: function (val) {
   this.$store.dispatch("pbxElements", null);
  },
  concatenateData: function (val) {
   this.setTableData();
  },
  searchQueue: function (val) {
   let arrayOfNumbers = [];
   if (val?.length > 0) {
    if (Array.isArray(val)) {
     val.forEach(res => {
      let number = res.split("-")[0];
      arrayOfNumbers.push(number);
     });
    } else {
     arrayOfNumbers.indexOf(val.split("-")[0]) >= 0
      ? arrayOfNumbers.splice(arrayOfNumbers.indexOf(val.split("-")[0]), 1)
      : arrayOfNumbers.push(val.split("-")[0]);
    }
    this.listOfFilteredQueues = arrayOfNumbers;
   } else {
    this.listOfFilteredQueues = [];
   }
   this.stringOfQueues = this.listOfFilteredQueues.join(",");
   this.setTableData();
  },
 },
 mounted() {
  // if (!this.period && !this.pbxPeriodSelected) {
  //  this.period = this.currentMonthAndYearForPbx();
  // }
  // if (this.pbxPeriodSelected) this.period = this.pbxPeriodSelected;

  // if (this.pbx3cxTableConfig) {
  //  this.timeRange = this.pbx3cxTableConfig?.following_interval;
  //  this.timeGap = this.pbx3cxTableConfig?.initial_interval;
  //  this.numberOfColumns = this.pbx3cxTableConfig?.count_interval;
  // }

  if (this.pbxElements) {
   this.selectedElement = this.pbxElements;

   if (this.pbxElementType !== this.urlType)
    this.$store.dispatch("pbxElements", null);
  }
 },
 computed: {
  filteredData() {
   return this.sortedData().filter(data => {
    if (this.searchExtension?.length > 0) {
     let flag = false;
     this.searchExtension.forEach(user => {
      if (user.includes(data.user)) {
       flag = true;
      }
     });
     return flag;
    }
    return data;
   });
  },
  ...mapGetters([
   "hostName",
   "hostTimeZone",
   "pbxPeriodSelected",
   "pbxElements",
   "pbxMap",
   "pbxElementType",
   "pbx3cxTableConfig",
   "pbxTimeSelected",
  ]),
 },
};
</script>

<style>
.switch-group {
 position: absolute;
 right: 1.3rem;
 top: 23.5rem;
}
.switch-group-no-info {
 position: absolute;
 right: 1.3rem;
 top: 18.5rem;
}
</style>
